import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {Link} from 'react-router-dom';

import {
    setItems
} from '../../modules/productTypes'

import {
    setConnectorItems
} from '../../modules/connectorTypes'

import {
    setProductType
} from '../../modules/order'

import axios from 'axios'
import querystring from 'querystring'

import RadioFormType from './../../components/RadioFormType';

class ProductType extends React.Component {

    componentWillMount () {
        this.getProductTypes();
    }

    componentDidMount() {
        ReactDOM.findDOMNode(this).scrollIntoView();
    }

    getProductTypes(){
        const _this = this;

        axios({
            method: 'post',
            url: _this.props.config.api_path+'api/getProductTypes'
        })
        .then(function (response) {
            _this.props.setItems({
                items: response.data.types
            })
        })
        .catch(function (error) {
            console.log(error)
        })
    }

    onProductTypeChanged(value){

        console.log(value);

        this.props.setProductType({
            product_type: value
        });

        this.getConnectorTypes(value);
    }

    getConnectorTypes(product_type){
        const _this = this;

        axios.post(_this.props.config.api_path+'api/getConnectorTypes', querystring.stringify({
            product_type: product_type
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            _this.props.setConnectorItems({
                items: response.data.types
            })
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    render()
    {
        return(
            <div className="content-container">
                <div className="content">
                    <div className="configurator_form">
                        <div className="row">
                            <h1>1. opticalcon cable type</h1>
                            <p>Select the type of opticalCON cable you want to start configuring.</p>

                            {this.props.productTypes.items.length > 0 &&
                                <RadioFormType items={this.props.productTypes.items} input_name="cable_type"
                                           onTypeChanged={(value) => this.onProductTypeChanged(value)} checked={this.props.order.product_type} />
                            }
                        </div>

                        {this.props.order.product_type !== null &&
                            <div>
                                <div className="hr"></div>
                                <div className="align-right">
                                    <Link to="/ConnectorType" className="a_button"><button type="button">Next: Choose your connector type »</button></Link>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    config: state.config,
    productTypes: state.productTypes,
    order: state.order
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setItems,
    setConnectorItems,
    setProductType
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductType)



// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/ProductType/index.js